import { Services } from '@sigma-frontend-libs/commons'

import info from '@/components/services/servers/item/info'
import date from '@/components/templates/service/item/date'

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.value
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        'hover-parent': true,
        'hover-parent--opacity': true,
        [`${Services.servers}-item`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
